module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enabled),
      expression: "enabled"
    }],
    staticClass: "saved-filter"
  }, [(!_vm.formOpened) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFilter),
      expression: "selectedFilter"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.loadFilter(_vm.selectedFilter)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.t('Select')))]), _vm._v(" "), _vm._l((_vm.savedFilters), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        return _vm.openForm()
      }
    }
  }, [_vm._v("+")])]) : _vm._e(), _vm._v(" "), (_vm.formOpened) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control user-filter-value",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        return _vm.save(_vm.name)
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Save')))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success btn-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.closeForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Cancel')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f35f5f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterValue.vue
// module id = 1235
// module chunks = 2